export type DiscoverExploreSearchFormData = {
  from: string;
  to: string;
  depart: string;
  durationDays: string;
};

export const DISCOVER_EXPLORE_SEARCH_INITIAL_VALUES: DiscoverExploreSearchFormData = {
  from: '',
  to: '',
  depart: '',
  durationDays: '',
};

export const DISCOVER_TOUR_DURATION_MIN = 0;
export const DISCOVER_TOUR_DURATION_MAX = 365;

export function formatUpToDurationDays(days: number): string {
  if (days === 1) return 'Up to 1 day';
  return `Up to ${days} days`;
}

export function parseDurationDaysValue(raw: string): number | undefined {
  const trimmed = raw.trim();
  if (!trimmed) return undefined;
  const n = Number.parseInt(trimmed, 10);
  if (!Number.isFinite(n) || n < DISCOVER_TOUR_DURATION_MIN || n > DISCOVER_TOUR_DURATION_MAX) {
    return undefined;
  }
  return n;
}

export function clampDurationDaysInput(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 3);
  if (!digits) return '';
  const n = Number.parseInt(digits, 10);
  if (!Number.isFinite(n)) return '';
  if (n > DISCOVER_TOUR_DURATION_MAX) return String(DISCOVER_TOUR_DURATION_MAX);
  return String(n);
}
